module.exports = __webpack_public_path__ + "static/media/Palossand_gaussian2.6de44f67.png";